import { Instagram, MessageCircle } from "lucide-react";
import { ORG } from "../data/siteData";

export const Footer = () => (
  <footer className="bg-[#0F0F11] border-t border-white/10" data-testid="footer">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-14 grid md:grid-cols-3 gap-10">
      <div>
        <div className="flex items-center gap-3">
          <img src={`${process.env.PUBLIC_URL}/assets/logo-amacli.png`} alt="Logo AMACLI" className="h-12 w-12 object-contain" />
          <div>
            <p className="font-heading font-bold text-[#F8FAF8]">AMACLI</p>
            <p className="text-[10px] text-zinc-500 uppercase tracking-widest">Associação Judô Itakira</p>
          </div>
        </div>
        <p className="mt-5 text-sm text-zinc-500 leading-relaxed">
          Entidade sem fins lucrativos comprometida com o esporte, a cultura, o lazer e a transparência pública em Canaã dos Carajás - PA.
        </p>
      </div>
      <div>
        <h4 className="text-xs font-semibold uppercase tracking-[0.25em] text-zinc-400 mb-4">Navegação</h4>
        <ul className="space-y-2 text-sm">
          <li><a href="#sobre" data-testid="footer-link-sobre" className="text-zinc-500 hover:text-white transition-colors duration-200">Quem Somos</a></li>
          <li><a href="#transparencia" data-testid="footer-link-transparencia" className="text-zinc-500 hover:text-white transition-colors duration-200">Portal da Transparência</a></li>
          <li><a href="#galeria" data-testid="footer-link-galeria" className="text-zinc-500 hover:text-white transition-colors duration-200">Galeria</a></li>
          <li><a href={`${process.env.PUBLIC_URL}/documentos/estatuto-social.pdf`} target="_blank" rel="noopener noreferrer" data-testid="footer-link-estatuto" className="text-zinc-500 hover:text-white transition-colors duration-200">Estatuto Social (PDF)</a></li>
        </ul>
      </div>
      <div>
        <h4 className="text-xs font-semibold uppercase tracking-[0.25em] text-zinc-400 mb-4">Canais Oficiais</h4>
        <div className="flex gap-3">
          <a href={`https://wa.me/${ORG.whatsapp}`} target="_blank" rel="noopener noreferrer" data-testid="footer-link-whatsapp" aria-label="WhatsApp" className="h-10 w-10 rounded-full border border-white/10 hover:border-[#DC2626] flex items-center justify-center text-zinc-400 hover:text-white transition-colors duration-200">
            <MessageCircle className="h-4 w-4" />
          </a>
          <a href={ORG.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-link-instagram" aria-label="Instagram" className="h-10 w-10 rounded-full border border-white/10 hover:border-[#DC2626] flex items-center justify-center text-zinc-400 hover:text-white transition-colors duration-200">
            <Instagram className="h-4 w-4" />
          </a>
        </div>
        <p className="mt-5 text-xs text-zinc-600 font-mono">CNPJ {ORG.cnpj}</p>
      </div>
    </div>
    <div className="border-t border-white/5 py-6 text-center px-4">
      <p className="text-xs text-zinc-600">© {new Date().getFullYear()} {ORG.razaoSocial}. Todos os direitos reservados. · Prestação de contas em conformidade com o TCM-PA.</p>
    </div>
  </footer>
);
